export const unicodesMap = {
  'icon-Bio_agefill': 59905,
  'icon-Calendarfill': 59906,
  'icon-CellsFill': 59907,
  'icon-Chart2fill': 59908,
  'icon-Chartfill': 59909,
  'icon-Fatfill': 59910,
  'icon-Kettlebellfill': 59911,
  'icon-Musclefill': 59912,
  'icon-Rulerfill': 59913,
  'icon-Sleepfill': 59914,
  'icon-Stepfill': 59915,
  'icon-Time': 59916,
  'icon-Waterfill': 59917,
  'icon-account': 59918,
  'icon-accountfill': 59919,
  'icon-arrow-down': 59920,
  'icon-arrow-left': 59921,
  'icon-arrow-left-1': 59922,
  'icon-arrow-right': 59923,
  'icon-arrow-right-1': 59924,
  'icon-arrow-up': 59925,
  'icon-attachment': 59926,
  'icon-bag': 59927,
  'icon-bagfill': 59928,
  'icon-bar': 59929,
  'icon-bookmark': 59930,
  'icon-calendar': 59931,
  'icon-calendar_search': 59932,
  'icon-call': 59933,
  'icon-camera': 59934,
  'icon-cancel': 59935,
  'icon-cancel2': 59936,
  'icon-card': 59937,
  'icon-cart': 59938,
  'icon-case': 59939,
  'icon-chart': 59940,
  'icon-chart2': 59941,
  'icon-check': 59942,
  'icon-check2': 59943,
  'icon-copy': 59944,
  'icon-delete': 59945,
  'icon-diamond': 59946,
  'icon-discount': 59947,
  'icon-doc': 59948,
  'icon-edit': 59949,
  'icon-exchange': 59950,
  'icon-filter': 59951,
  'icon-flash': 59952,
  'icon-folder': 59953,
  'icon-folder-1': 59954,
  'icon-grid': 59955,
  'icon-gridfill': 59956,
  'icon-group': 59957,
  'icon-hangup': 59958,
  'icon-heart': 59959,
  'icon-heartfill': 59960,
  'icon-hide': 59961,
  'icon-home2': 59962,
  'icon-house': 59963,
  'icon-housefill': 59964,
  'icon-image': 59965,
  'icon-info': 59966,
  'icon-info2': 59967,
  'icon-kebab': 59968,
  'icon-link': 59969,
  'icon-list': 59970,
  'icon-loading': 59971,
  'icon-location': 59972,
  'icon-lock': 59973,
  'icon-logout': 59974,
  'icon-mail': 59975,
  'icon-mic': 59976,
  'icon-minus': 59977,
  'icon-money': 59978,
  'icon-mute': 59979,
  'icon-noconnection': 59980,
  'icon-notification': 59981,
  'icon-plus': 59982,
  'icon-plus2': 59983,
  'icon-present': 59984,
  'icon-qr': 59985,
  'icon-ruble': 59986,
  'icon-search': 59987,
  'icon-send': 59988,
  'icon-settings': 59989,
  'icon-share': 59990,
  'icon-show': 59991,
  'icon-smartphone': 59992,
  'icon-sort-horizontal': 59993,
  'icon-sort-vertical': 59994,
  'icon-speed': 59995,
  'icon-stack': 59996,
  'icon-starfill': 59997,
  'icon-staroutline': 59998,
  'icon-unlock': 59999,
  'icon-unmute': 60000,
  'icon-video': 60001,
  'icon-videooff': 60002,
  'icon-volume': 60003,
  'icon-wallet': 60004,
  'icon-warning': 60005,
};
